export default "__VITE_ASSET__BxVYM5nD__"